import PropTypes from 'prop-types';
import SportsFilterContainer from './sports-filter-container.js';
import MojitoCore from 'mojito/core';

const { UIView } = MojitoCore.Presentation;

/**
 * Renders a {@link Mojito.Presentation.Components.SportsFilter|SportsFilter} above its content and shares the selected sport with it.
 * The content is provided as a render function. It receives the selected sport id and a callback used by the content
 * to report which sports it can show, which become the options of the sports filter.
 *
 * @example
 * <SportsFilterContainer config={config.sportsFilterContainer}>
 *     {(selectedSportId, applySports) => (
 *         <EventCardsCarousel selectedSportId={selectedSportId} onSportsChange={applySports} />
 *     )}
 * </SportsFilterContainer>
 *
 * @class SportsFilterContainer
 * @name module
 *
 * @memberof Mojito.Modules.SportsFilterContainer
 */

/**
 * SportsFilterContainer prop types.
 *
 * @property {Array<string>} [sportIds = []] - Sports shown in the filter. An empty list hides the filter until the content reports sports through the render prop.
 * @property {Function} children - Render function called with the selected sport id (undefined when all sports are selected)
 * and a callback that takes the list of sport ids the content can show.
 * @property {string} [class] - Class name assigned to the root element.
 *
 * @memberof Mojito.Modules.SportsFilterContainer.module
 */
const propTypes = {
    sportIds: PropTypes.arrayOf(PropTypes.string),
    children: PropTypes.func.isRequired,
    class: PropTypes.string,
};

const defaultProps = {
    sportIds: [],
};

export default UIView('SportsFilterContainer', SportsFilterContainer, propTypes, defaultProps);
